function FailedCard(props) {
    return(
        <div className="failed-card">
            {props.message1}<br />
            {props.message2}
        </div>
    );
}

export default FailedCard